import classNames from "classnames";
import Badge from "components/badge";
import { FLOW } from "components/fareBreakup";
import { Container, Typography } from "ct-design";
import dayjs from "dayjs";
import { FunctionComponent } from "react";
import { cancellationPolicy } from "src/containers/chart/types";
import { formatFare } from "src/utils/generalUtils";

interface Props {
  cancellationPolicyData?: cancellationPolicy;
  tableWidth?: string;
  flow: FLOW.POST | FLOW.PRE;
  valueTabAlginment?: "center" | "right";
}

const CancellationPolicy: FunctionComponent<Props> = (props) => {
  const {
    cancellationPolicyData,
    tableWidth = "100%",
    flow = FLOW.PRE,
    // valueTabAlginment = "center",
  } = props;

  const valueTabClasses = classNames(
    "py-4 px-3 ta-center  ta-center bb-solid bc-line-500 flex  px-4 flex-end"
  );

  const valueTabHeadingClass = classNames(
    "py-4 px-3 bb-solid bc-line-500 ta-right"
  );
  return (
    <>
      <div className="w-100p">
        {cancellationPolicyData &&
        cancellationPolicyData?.policy?.length > 0 ? (
          <table
            style={{
              borderCollapse: "separate",
              borderSpacing: "0px",
              width: tableWidth,
            }}
            className=" ba-solid bc-line-500 br-12 o-hidden"
          >
            <thead style={{ backgroundColor: "#f3f3f3" }}>
              <tr>
                <th
                  className="w-50p py-4 px-3 bb-solid bc-line-500 ta-left"
                  style={{ borderRight: "1px solid #e6e6e6" }}
                >
                  <Typography variant="L3">Cancel between</Typography>
                </th>
                <th className={valueTabHeadingClass}>
                  <Typography variant="L3">
                    <>
                      {(!cancellationPolicyData.policy[0]?.refundAmount &&
                        cancellationPolicyData.policy[0]?.refundAmount !== 0) ||
                      cancellationPolicyData.policy[0].refundAmount === null ? (
                        <>Cancellation Charges</>
                      ) : (
                        <>Refund amount</>
                      )}
                    </>
                  </Typography>
                </th>
              </tr>
            </thead>
            <tbody>
              {cancellationPolicyData.policy?.map((item, index) => (
                <tr key={index}>
                  <td
                    className="py-4 px-3 bb-solid bc-line-500"
                    style={{ borderRight: "1px solid #e6e6e6" }}
                  >
                    <Typography variant="P3">
                      {index === 0
                        ? `Now - ${dayjs(
                            cancellationPolicyData.policy[0]?.duration
                          ).format("D MMM, hh:mm A")}`
                        : `${dayjs(
                            cancellationPolicyData.policy[index - 1]?.duration
                          ).format("D MMM, hh:mm A")} -
              ${dayjs(cancellationPolicyData.policy[index]?.duration).format(
                "D MMM, hh:mm A"
              )}`}
                    </Typography>
                  </td>

                  <td className={valueTabClasses}>
                    {item.isCFNRBenefit &&
                    (item.strikeThroughCancellationPer ||
                      item.amount > 0 ||
                      item?.refundAmount > 0) ? (
                      <Container className=" w-100p flex flex-end">
                        <Badge
                          text={"Full refund with ClearChoice Max"}
                          textColor="#5F1AB6"
                          type="micro"
                          backgroundColor="#F3F3F3"
                          wrapperClass="h-5"
                        />
                      </Container>
                    ) : null}
                    <Container>
                      <Typography
                        variant="P3"
                        className="ta-right ml-3"
                        isStriked={
                          flow === FLOW.PRE &&
                          item?.isCFNRBenefit &&
                          (!!item?.strikeThroughCancellationPer ||
                            item.amount > 0)
                        }
                        width={item.amount > 0 ? "80px" : "32px"}
                      >
                        {flow != FLOW.POST ? (
                          <>
                            {item.amount > 0 &&
                              `₹${formatFare(item.amount)} per seat `}
                            {item.amount > 0 &&
                              item.cancellationPer > 0 &&
                              ` + `}
                            {item.cancellationPer > 0 ||
                            (item.cancellationPer === 0 &&
                              item.amount === 0) ? (
                              <>
                                {item.isCFNRBenefit &&
                                (item.strikeThroughCancellationPer ||
                                  item.amount > 0) ? (
                                  <>{item.strikeThroughCancellationPer}%</>
                                ) : (
                                  <>{item.cancellationPer}%</>
                                )}
                              </>
                            ) : null}
                          </>
                        ) : (
                          <>
                            {item.refundAmount == null
                              ? (item.cancellationPer > 0 ||
                                  (item.cancellationPer === 0 &&
                                    item.amount === 0)) && (
                                  <>{item.cancellationPer}%</>
                                )
                              : (item.refundAmount > 0 ||
                                  (item.refundAmount === 0 &&
                                    item.amount === 0)) && (
                                  <>₹{formatFare(item.refundAmount)}</>
                                )}
                          </>
                        )}
                      </Typography>
                    </Container>
                    {item.isCFNRBenefit &&
                    (item.strikeThroughCancellationPer || item.amount > 0) &&
                    flow === FLOW.PRE ? (
                      <Typography
                        isStriked={false}
                        variant="P3"
                        className="ml-2 ta-right"
                      >
                        {item.cancellationPer}%
                      </Typography>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
        <Container className="mt-4 ">
          {cancellationPolicyData?.text.map((item, index) => {
            if (
              !cancellationPolicyData?.policy?.length &&
              cancellationPolicyData.text?.length === 1
            ) {
              return (
                <Typography key={index} variant="P2">
                  {item}
                </Typography>
              );
            } else {
              return (
                <ul key={index} className="mx-6">
                  <li className="fs-14 fw-400 lh-20 mb-2">{item}</li>
                </ul>
              );
            }
          })}
        </Container>
      </div>
    </>
  );
};

export default CancellationPolicy;
